import React from 'react'
import Modalizer from 'components/modalizer/modalizer'
import LessonsPicker from 'components/lessons_picker/lessons_picker'

const LessonsPickerModal = props => (<Modalizer modalName={props.modalName} width='552px' closeAction={props.closeModal}>
	<LessonsPicker
		folderName={props.folderName}
		title={props.title}
		subtitle={props.subtitle}
		placeholder={props.placeholder}
		showType={props.showType}
		showPrice={props.showPrice}
		searchLessons={props.searchLessons}
		saveLessons={props.saveLessons}
		cancel={props.cancel} />
</Modalizer>)

export default LessonsPickerModal
